<template>
  <component
  :is="to ? 'router-link' : 'a'"
  v-bind="linkProps"
  class="btnCta"
  :class="variant ? `btn--${variant}` : ''"
  :style="{ '--btn-color': resolvedColor, '--btn-hover-color': resolvedHoverColor }"
>
  <span class="btnLabel">{{ label }}</span>
</component>
</template>

<script>
const VARIANT_DEFAULTS = {
  red:    { color: "#d70000", hoverColor: "#b30000" },
  gold:   { color: "#E1AC1B", hoverColor: "#E6C200" },
  grey:   { color: "#C0C0C0", hoverColor: "#A9A9A9" },
  gradi1: { color: "#3495D5", hoverColor: "#2a7ab8" },
  gradi2: { color: "#3495D5", hoverColor: "#2a7ab8" },
};

export default {
  name: "ButtonSecondary",
  props: {
    label: {
      type: String,
      required: true,
    },
    // 'red' | 'gold' | 'grey' | 'gradi1' | 'gradi2' | '' (pas d'image de fond)
    variant: {
      type: String,
      default: "",
    },
    // Couleur de bordure — surcharge la couleur par défaut du variant
    color: {
      type: String,
      default: "",
    },
    // Couleur au survol — si absent, utilise la valeur par défaut du variant
    hoverColor: {
      type: String,
      default: "",
    },
    to: {
      type: String,
      default: "",
    },
    href: {
      type: String,
      default: "#",
    },
    target: {
      type: String,
      default: "_self",
    },
  },
  computed: {
    resolvedColor() {
      if (this.color) return this.color;
      return VARIANT_DEFAULTS[this.variant]?.color || "#d70000";
    },
    resolvedHoverColor() {
      if (this.hoverColor) return this.hoverColor;
      return VARIANT_DEFAULTS[this.variant]?.hoverColor || this.resolvedColor;
    },
    linkProps() {
      if (this.to) return { to: this.to };
      return { href: this.href, target: this.target };
    },
  },
};
</script>

<style lang="scss" scoped>
.btnCta {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 220px;
  height: 70px;
  border-radius: 15px;
  text-decoration: none;
  font-weight: 700;
  font-size: 0.9rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  border: 2px solid var(--btn-color, #d70000);
  color: $textColor;
  transition: border-color 0.2s, color 0.2s;
  background-repeat: no-repeat;
  background-size: contain;
  background-position: bottom;
  &:hover {
    text-decoration: none;
    border-color: var(--btn-hover-color, var(--btn-color, #d70000));
    color: var(--btn-hover-color, var(--btn-color, #d70000));
  }
}

.btn--red    { background-image: url("../assets/image/components/subBtnRed.svg"); }
.btn--gold   { background-image: url("../assets/image/components/subBtnGold.svg"); }
.btn--grey   { background-image: url("../assets/image/components/subBtnGrey.svg"); }
.btn--gradi1 { background-image: url("../assets/image/components/subBtnGradi1.svg"); }
.btn--gradi2 {
  border-color: transparent;
  background-image:
    url("../assets/image/components/subBtnGradi2.svg"),
    linear-gradient(white, white),
    linear-gradient(to right, #87cfff, #c07cff);
  background-origin: padding-box, border-box, border-box;
  background-clip: padding-box, padding-box, border-box;
  background-size: contain, auto, auto;
  background-position: bottom, 0 0, 0 0;
  background-repeat: no-repeat;
}
.btnLabel {
  background-color: rgba(255, 255, 255, 0.5);
  padding: 4px 10px;
  border-radius: 6px;
}
</style>
